import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { IoMdPersonAdd } from "react-icons/io";
import { Formik } from "formik";
import { Box, CircularProgress, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Swal from "sweetalert2";

import FieldAgentAPI from "../../../../services/field-agent-api";
import { useNavigate, Link } from "react-router-dom";
import { addAgentValidation } from "../../../../validations/field.agent.validation";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function AddAgent() {
  const [open, setOpen] = useState(false);

  const { addFieldAgentAPI } = new FieldAgentAPI();

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const initialValues = {
    phone: "",
    email: "",
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        startIcon={<IoMdPersonAdd />}
        onClick={handleClickOpen}
        style={{ marginRight: "5px", textTransform: "capitalize" }}
      >
        Add Agent
      </Button>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="sm"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add Field Agent
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={addAgentValidation}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              setTimeout(async () => {
                const res = await addFieldAgentAPI(values);

                // console.log("res-----------", res);

                if (res.ok) {
                  navigate(`/field-agent-profile?id=${res.data.id}`);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: res.err,
                    showConfirmButton: false,
                    timer: 3000,
                  });
                }

                setSubmitting(false);
              }, 500);
            }}
          >
            {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid size={12}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="email"
                      label="Email"
                      variant="outlined"
                      helperText={touched.email && errors.email}
                      error={touched.email && errors.email}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={12}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="phone"
                      label="Phone"
                      variant="outlined"
                      helperText={touched.phone && errors.phone}
                      error={touched.phone && errors.phone}
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 10 }}
                      type="number"
                    />
                  </Grid>

                  {/* <Grid size={12}>
                          <TextField
                            fullWidth
                            autoComplete="off"
                            size="small"
                            name="password"
                            label="Password"
                            variant="outlined"
                            type="password"
                            helperText={touched.password && errors.password}
                            error={touched.password && errors.password}
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </Grid> */}

                  {/* <Grid size={12}>
                          <TextField
                            fullWidth
                            autoComplete="off"
                            size="small"
                            name="repeatPassword"
                            label="Re-enter Password"
                            variant="outlined"
                            type="password"
                            helperText={
                              touched.repeatPassword && errors.repeatPassword
                            }
                            error={
                              touched.repeatPassword && errors.repeatPassword
                            }
                            value={values.repeatPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </Grid> */}

                  <Grid size={12} textAlign="center">
                    <Button
                      color="primary"
                      // disabled={true}
                      variant="contained"
                      fullWidth
                      type="submit"
                      size="large"
                      endIcon={
                        isSubmitting && <CircularProgress size="1.4rem" style={{ color: "#ffffff", marginLeft: 6 }} />
                      }
                      sx={{
                        "&.Mui-disabled": {
                          color: "#333333",
                          background: "#ddddddd",
                        },
                        width: 200,
                        margin: 2,
                        textTransform: "capitalize",
                      }}
                    >
                      SUBMIT
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
